export default "__VITE_ASSET__b2a6491a__"